export default __webpack_public_path__ + "static/media/FlyingFrog19.a21a6327.png";